<template>
  <NuxtLayout>
    <main class="error-page grid">
      <section class="code-section">
        <h1 class="title">{{ error.statusCode }}</h1>
        <LotusIcon class="lotus-icon" />
      </section>
      <section class="description-section">
        <h2
          class="subtitle t-h5"
          v-html="nbsp(t(`errors.${error.statusCode}`))"
        />
        <p class="description t-p-m-130" v-html="nbsp(t('back-to-home'))" />
        <BaseButton
          :tag="NuxtLink"
          :to="localePath('/')"
          size="l"
          :text="t('home')"
          @click.prevent.capture="handleBack"
        />
      </section>
    </main>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { NuxtLink } from '#components'
import LotusIcon from '@/assets/icons/lotus.svg?component'
import { useWebsiteSettings } from '@/state/websiteSettings'

withDefaults(
  defineProps<{
    error: Record<PropertyKey, unknown>
  }>(),
  {
    error: () => ({ statusCode: 500 })
  }
)

const { t } = useI18n()
const localePath = useLocalePath()
const handleBack = () => clearError({ redirect: localePath('/') })

await useWebsiteSettings()
</script>

<style lang="scss" scoped>
.code-section,
.description-section {
  @include column(xs, 12);
  position: relative;
  z-index: 0;
  min-height: calc(50svh - #{$nav-height} / 2);
}

.code-section {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
}

.title {
  font-family: $font-display;
  font-size: rem(142px);
  font-weight: 600;
  line-height: 1.1;
  color: $layout-text-02;
  text-align: center;
  letter-spacing: 0.01em;
}

.lotus-icon {
  position: absolute;
  bottom: rem(-58px);
  left: 50%;
  z-index: -1;
  width: 100%;
  max-width: rem(324px);
  height: auto;
  aspect-ratio: 1 / 1;
  color: #f7d8ce;
  transform: translateX(-50%);
}

.description-section {
  @include flex-col;
  align-items: center;
  padding-block: rem(32px);
  background: $layout-background-03;

  > * {
    max-width: rem(283px);
  }
}

.subtitle {
  margin-bottom: rem(10px);
  color: $layout-text-02;
  text-align: center;
}

.description {
  margin-bottom: rem(40px);
}
</style>
